<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { settingStore } from "@/store/Modules/setting.js"
import { mapState } from "pinia"
import { mapStores } from "pinia"
import { mapActions } from "pinia"
export default {
  created() {
    this.getSettingsAction()
  },
  // computed: {
  //   // ...mapState(settingStore, ["getSlideShows"]),
  // },
  methods: { ...mapActions(settingStore, ["getSettingsAction"]) },
}
</script>
